export function LoadingSpinner() {
    return <div style={{ maxHeight: '5rem' }} className="Flex JustifyCenter Pad1"><img src="/assets/svg-loaders/grid.svg" /></div>

}